<template>
	<Container>
		<Subtitle> {{ $t('Contratacion_comercial') }} </Subtitle>
		<div class="p-4">
			<label class="d-block mt-2 mb-4 f-bold">{{ $t('Datos_delegado') }}:</label>
			<div class="lg:flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('Solicitante') }}</label>
					<input type="text" v-model="contractData.applicant_name" class="w-full border-t-0 mt-2 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					<div v-if="$v.contractData.applicant_name.$dirty" class="text-left">
						<div class="text-sm text-red-500" v-if="!$v.contractData.applicant_name.required">
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('email') }}</label>
					<input type="text" v-model="contractData.applicant_email" class="w-full border-t-0 mt-2 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					<div v-if="$v.contractData.applicant_email.$dirty" class="text-left">
						<div class="text-sm text-red-500" v-if="!$v.contractData.applicant_email.required">
							{{ $t('Campo_requerido') }}
						</div>
					</div>
					<span class="text-sm text-red-500" v-if="!$v.contractData.applicant_email.email">{{ $t('Email_no_valido') }}</span>
				</div>
			</div>
			<label class="d-block mt-2 mb-4 f-bold">{{ $t('Datos_contratacion') }}:</label>
			<div class="lg:flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('Tipo_contratacion') }}</label>
					<select v-model="contractData.contract_category" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none">
						<option v-for="(category, index) in contract_categories" :value="category.id" :key="index">
							{{ category.category }}
						</option>
					</select>
					<div v-if="$v.contractData.contract_category.$dirty" class="text-left">
						<div class="text-sm text-red-500" v-if="!$v.contractData.contract_category.required">
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('Recommended') }}</label>
					<input type="text" v-model="contractData.recommended" class="w-full border-t-0 mt-2 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
				</div>
			</div>
			<div class="lg:flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('Tipo_comercial') }}</label>
					<select v-model="contractData.contract_type" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none">
						<option v-for="(type, index) in types" :value="type.id" :key="index">
							{{ type.type }}
						</option>
					</select>
					<div v-if="$v.contractData.contract_type.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.contractData.contract_type.required">
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('Base_comercial') }}</label>
					<select v-model="contractData.comercial_base" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none">
						<option value=""></option>
						<option v-for="(comercial, index) in commercialBase" :value="comercial.id" :key="index">
							{{ comercial.base }}
						</option>
					</select>
					<div v-if="$v.contractData.comercial_base.$dirty" class="text-left">
						<div class="text-sm text-red-500" v-if="!$v.contractData.comercial_base.required">
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
			</div>
			<div class="flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('Categoria_comercial') }}</label>
					<select v-model="contractData.comercial_category_id" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none">
						<option :value="null"></option>
						<template v-if="contractData.comercial_base == 1">
							<option v-for="(category, index) in categories.filter(c => categoriesRelation[brand.toLowerCase()][0].includes(c.id))" :value="category.id" :key="index">{{ category.category }}</option>
						</template>
						<template v-if="contractData.comercial_base == 2">
							<option v-for="(category, index) in categories.filter(c => categoriesRelation[brand.toLowerCase()][1].includes(c.id))" :value="category.id" :key="index">{{ category.category }}</option>
						</template>
						<template v-if="contractData.comercial_base == 3">
							<option v-for="(category, index) in categories.filter(c => categoriesRelation[brand.toLowerCase()][2].includes(c.id))" :value="category.id" :key="index">{{ category.category }}</option>
						</template>
						<template v-if="contractData.comercial_base == 4">
							<option v-for="(category, index) in categories.filter(c => categoriesRelation[brand.toLowerCase()][3].includes(c.id))" :value="category.id" :key="index">{{ category.category }}</option>
						</template>
					</select>
					<div v-if="$v.contractData.comercial_category_id.$dirty" class="text-left">
						<div class="text-sm text-red-500" v-if="!$v.contractData.comercial_category_id.required">
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('organizacion') }}</label>
					<select v-model="contractData.organization_id" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none">
						<option v-for="(organization, index) in organizations" :value="organization.id" :key="index">
							{{ organization.name }}
						</option>
					</select>
					<div v-if="$v.contractData.organization_id.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.contractData.organization_id.required">
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
			</div>
			<div class="flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('Delegation') }}</label>
					<input type="text" v-model="contractData.delegation_id" class="w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					<div v-if="$v.contractData.delegation_id.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.contractData.delegation_id.required">
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('Responsable') }}</label>
					<input type="text" v-model="contractData.responsable_id" class="w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					<div v-if="$v.contractData.responsable_id.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.contractData.responsable_id.required">
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
			</div>
			<div class="lg:flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('team') }}</label>
					<input type="text" v-model="contractData.team" class="w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					<div v-if="$v.contractData.team.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.contractData.team.required">
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
				<div v-if="contractData.contract_type == 2" class="lg:w-1/2 mb-4 lg:pl-2">
					<div class="lg:w-1/2">
						<label class="block mb-2">{{ $t('TipoRetencion') }}</label>
						<select v-model="contractData.retention_id" class="w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none">
							<option v-for="(retention, index) in retentions" :value="retention.id" :key="index">
								{{ retention.type }}
							</option>
						</select>
					</div>
				</div>
			</div>
			<div v-if="contractData.contract_category == 9" class="flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('AhorreluzCode') }}</label>
					<input type="text" v-model="contractData.ahorreluz_code" class="w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" maxlength="155" />
				</div>
				<div class="lg:w-1/2 mb-4 lg:pr-2 lg:pl-2">
					<label class="block mb-2">{{ $t('DeliveryAddress') }}</label>
					<input type="text" v-model="contractData.delivery_address" class="w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
				</div>
			</div>

			<div class="lg:flex">
				<div class="lg:w-2/3 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('Campaign') }}</label>
					<dual-list v-if="DualListOptions" id="vueduallist" :options="DualListOptions" />
					<div v-if="$v.DualListOptions.selectedItems.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.DualListOptions.selectedItems.required">
							{{ $t('campaign_required') }}
						</div>
					</div>
				</div>
			</div>
			<label class="d-block mt-2 mb-4 f-bold">Datos de contacto:</label>
			<div class="lg:flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('Nombre') }} / {{ $t('RazonSocial') }}</label>
					<input type="text" max="100" v-model="contractData.name" class="w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					<div v-if="$v.contractData.name.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.contractData.name.required">
							{{ $t('name_required') }}
						</div>
					</div>
				</div>

				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('CIF/NIF') }}</label>
					<input type="text" v-model="contractData.document" maxlength="9" class="w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					<div v-if="$v.contractData.document.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.contractData.document.required">
							{{ $t('document_required') }}
						</div>
					</div>
				</div>
			</div>
			<div class="flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('Domicilio') }}</label>
					<input type="text" v-model="contractData.domicilio" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					<div v-if="$v.contractData.domicilio.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.contractData.domicilio.required">
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('zipcode') }}</label>
					<input type="text" v-model="contractData.zipcode" @keydown="ValidateNumber($event)" maxlength="5" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					<div v-if="$v.contractData.zipcode.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.contractData.zipcode.required">
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
			</div>
			<div class="flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('Poblacion') }}</label>
					<input type="text" v-model="contractData.poblacion" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					<div v-if="$v.contractData.poblacion.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.contractData.poblacion.required">
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('Telefono_movil') }}</label>
					<input type="text" v-model="contractData.phone" @keydown="ValidateNumber($event)" minlength="9" maxlength="9" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					<div v-if="$v.contractData.phone.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.contractData.phone.required">
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
			</div>
			<div class="flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('Telefono') }}</label>
					<input type="text" v-model="contractData.cellphone" @keydown="ValidateNumber($event)" minlength="9" maxlength="9" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('email') }}</label>
					<input type="text" v-model="contractData.email" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					<div v-if="$v.contractData.email.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.contractData.email.required">
							{{ $t('email_required') }}
						</div>
					</div>
					<span class="text-sm text-red-500" v-if="!$v.contractData.email.email">{{ $t('Email_no_valido') }}</span>
				</div>
			</div>
			<div class="flex" v-if="contractData.contract_type == 1">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('NifRepresentante') }} </label>
					<input type="text" v-model="contractData.representant_nif" minlength="9" maxlength="9" class="w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					<div v-if="contractData.contract_type == 1">
						<span class="text-sm text-red-500" v-if="$v.contractData.representant_nif.$error && !$v.contractData.representant_nif.required">{{ $t('Campo_requerido') }}</span>
					</div>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('TipoRepresentante') }} </label>
					<input type="text" v-model="contractData.representant_type" class="w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					<div v-if="contractData.contract_type == 1">
						<span class="text-sm text-red-500" v-if="$v.contractData.representant_type.$error && !$v.contractData.representant_type.required">{{ $t('Campo_requerido') }}</span>
					</div>
				</div>
			</div>
			<div class="flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('Persona_contacto') }}</label>
					<input type="text" v-model="contractData.contact_person" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					<div v-if="$v.contractData.contact_person.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.contractData.contact_person.required">
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('Contacto_admon') }}</label>
					<input type="text" v-model="contractData.contact_admon" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					<div v-if="contractData.contract_type == 1">
						<span class="text-sm text-red-500" v-if="$v.contractData.contact_admon.$error && !$v.contractData.contact_admon.required">{{ $t('Campo_requerido') }}</span>
					</div>
				</div>
			</div>
			<div class="flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('Iban') }}</label>
					<input type="text" v-model="contractData.iban" minlength="24" maxlength="24" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" @input="sanitizeIban" />
					<div v-if="$v.contractData.iban.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.contractData.iban.required">
							{{ $t('Campo_requerido') }}
						</div>
					</div>
					<div class="text-sm text-red-500 mt-2" v-if="!$v.contractData.iban.minLength">
						{{ $t('iban_requerido') }}
					</div>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('SignatureType') }}</label>
					<select disabled v-model="contractData.signature_type" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none">
						<option value="sms">SMS</option>
					</select>
					<div v-if="$v.contractData.signature_type.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.contractData.signature_type.required">
							{{ $t('signature_type_required') }}
						</div>
					</div>
				</div>
			</div>
			<div v-if="contractData.contract_category == 9" class="flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('BusinessName') }}</label>
					<input type="text" v-model="contractData.business_name" class="w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
				</div>
			</div>
			<div v-if="contractData.contract_category == 10" class="flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('Objective') }}</label>
					<input type="text" v-model="contractData.objective" class="w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
				</div>
			</div>
			<div class="mt-4">
				<span class="font-bold"> {{ $t('Documentos') }}:</span>
				<div class="mt-4 lg:flex" v-if="contractData.status != 'COM' && contractData.status != 'PRO'">
					<div class="lg:w-1/2 ml-5">
						<label for="">{{ $t('Archivo') }}: </label>
						<span class="font-medium" v-if="file">{{ file.name }}</span>
						<div>
							<input id="file" class="inputfile" type="file" accept="application/pdf, image/*" @change="file_upload" />
							<label for="file" class="bg-secondary">{{ $t('selected_file') }}</label>
							<button class="bg-secondary text-white border-0 rounded-sm p-2 ml-2 mt-2 shadow-md outline-none cursor-pointer hover:text-primary focus:outline-none" @click.prevent="file_reset">
								{{ $t('delete_file') }}
							</button>
						</div>
					</div>

					<div class="lg:w-1/2 flex justify-end">
						<div>
							<button class="flex bg-secondary text-white px-3 py-2" @click="addFile()">
								<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
								{{ $t('Agregar') }}
							</button>
						</div>
					</div>
				</div>
				<table class="w-full mt-5">
					<tr>
						<th align="left">{{ $t('Orden') }}</th>
						<th align="left">{{ $t('Archivo') }}</th>
						<th></th>
					</tr>
					<tr v-for="(file, index) in contractData.files" v-bind:key="index">
						<td>{{ index + 1 }}</td>
						<td>{{ file.isNew ? file.file.name : file.name }}</td>
						<td>
							<div v-if="contractData.status != 'COM' && contractData.status != 'PRO'">
								<button v-if="file.isNew" @click="removeFile(index)">
									<i class="fas fa-times text-red-700"></i>
								</button>
								<button v-else @click="onRemoveFile(file)">
									<i class="fas fa-times text-red-700"></i>
								</button>
							</div>
						</td>
					</tr>
				</table>
			</div>
			<div class="lg:flex mt-6">
				<div class="lg:w-full mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('Comments') }}</label>
					<input type="text" v-model="contractData.comments" maxlength="50" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
				</div>
			</div>
			<div class="mt-5">
				<div class="flex justify-end">
					<ButtonBlack class="mt-4 mr-3" @click.native="copyForm">
						<div>Copiar Datos</div>
					</ButtonBlack>

					<ButtonBlack class="mt-4 mr-3" @click.native="pasteForm">
						<div>Pegar Datos</div>
					</ButtonBlack>

					<router-link to="/admin/listado/contratos">
						<ButtonBlack class="mt-4 mr-3">
							<div>
								{{ $t('Menu_contrataciones') }}
							</div>
						</ButtonBlack>
					</router-link>

					<ButtonBlack class="mt-4 mr-3" v-if="contractData.status == 'PRO'" @click.native="onCancelSign">
						<div>
							<i class="far fa-times-circle"></i>
							{{ $t('cancelarFirma') }}
						</div>
					</ButtonBlack>
					<ButtonBlack class="mt-4 mr-3" v-if="contractData.status == 'PEN'" :disabled="enableDisable" @click.native="onRequestSign">
						<div>
							<i class="fas fa-share-square"></i>
							{{ $t('SolicitarFirma') }}
						</div>
					</ButtonBlack>

					<!-- <ButtonBlack
						class="mt-4 mr-3"
						v-if="id && contractData.status != 'COM'"
						@click.native="onPreview"
					>
						<div>
							<i class="fas fa-search"></i>
							{{ $t('preview') }}
						</div>
					</ButtonBlack> -->

					<ButtonBlack class="mt-4 mr-3" v-if="contractData.status == 'COM'" @click.native="onDownload">
						<div>
							<i class="fas fa-download"></i>
							{{ $t('download') }}
						</div>
					</ButtonBlack>

					<ButtonBlack class="mt-4 mr-3" v-if="contractData.status != 'COM' && contractData.status != 'PRO'" @click.native="submitAndRequestSign">
						<div v-if="loading">
							<pulse-loader :loading="loading" :color="'#fff'" :size="'10px'"></pulse-loader>
						</div>
						<div v-else>
							<i class="fas fa-save"></i>
							Guardar y Solicitar Firma
						</div>
					</ButtonBlack>

					<ButtonBlack class="mt-4" v-if="contractData.status != 'COM' && contractData.status != 'PRO'" @click.native="submit">
						<div v-if="loading">
							<pulse-loader :loading="loading" :color="'#fff'" :size="'10px'"></pulse-loader>
						</div>
						<div v-else>
							<i class="fas fa-save"></i>
							{{ $t('Guardar') }}
						</div>
					</ButtonBlack>
				</div>
				<div v-if="error" class="mt-4">
					<p class="text-sm">{{ $t('server_error') }}</p>
					<p class="text-sm text-red-500" v-html="server_error"></p>
				</div>
			</div>
		</div>
	</Container>
</template>
<script>
import { fetchCommercialBaseSelect } from '@/apollo/commercialBase'
import { insertSingleContract, updateSingleContract } from '@/apollo/mutations/admin/contract'
import { deleteContractFile } from '@/apollo/mutations/admin/contract_files'
import { fetchOrganizationsSignatureSelect } from '@/apollo/organizations'
import { queryCampaignsList } from '@/apollo/queries/admin/campaigns'
import { fetchComercialCategory } from '@/apollo/queries/admin/comercial_category'
import { queryContractByPk } from '@/apollo/queries/admin/contract'
import { queryContractCategoryList } from '@/apollo/queries/admin/contract_category'
import { queryContractRetentionList } from '@/apollo/queries/admin/contract_retention'
import { queryContractTypesList } from '@/apollo/queries/admin/contract_types'
import DualList from '@/components/DualList.vue'
import { single } from '@/mixins'
import uploadFiles from '@/uploadFiles'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { email, minLength, required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
	apollo: {
		contract_categories: queryContractCategoryList(),
		allCampaigns: queryCampaignsList(),
		retentions: queryContractRetentionList(),
		commercialBase() {
			return fetchCommercialBaseSelect(this.user.rol_id)
		},
		types: queryContractTypesList(),
		categories: fetchComercialCategory(),
		organizations: fetchOrganizationsSignatureSelect(),
		contractData() {
			const query = queryContractByPk(this.id)
			query.skip = this.id == null
			return query
		}
	},
	data() {
		return {
			brand: process.env.VUE_APP_BRAND.toLowerCase(),
			categoriesRelation: {
				electryconsulting: [
					[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 24, 25, 26, 28, 29],
					[23, 27]
				],
				energoconsulting: [
					[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 15, 16, 17],
					[14, 18, 19],
					[1, 15, 19],
					[1, 19, 20, 21, 22, 23, 26, 24, 25]
				]
			},
			section: 'admin/listado/contrato',
			contractData: {
				name: null,
				phone: null,
				email: null,
				contract_type: null,
				signature_nop: null,
				status: null,
				document: null,
				user_id: null,
				country_id: this.country_id,
				signature_type: 'sms',
				organization_id: null,
				comercial_base: null,
				delegation_id: null,
				responsable_id: null,
				zipcode: null,
				domicilio: null,
				poblacion: null,
				cellphone: null,
				contact_person: null,
				contact_admon: null,
				iban: null,
				retention_id: 0,
				representant_nif: null,
				representant_type: null,
				team: null,
				comercial_category_id: null,
				contract_category: null,
				recommended: null,
				comments: null,
				applicant_name: null,
				applicant_email: null,
				campaigns: this.id ? null : [],
				files: [],
				ahorreluz_code: null,
				delivery_address: null,
				business_name: null,
				objective: null
			},
			enableDisable: false,
			file: null,
			types: [],
			organizations: [],
			commercialBase: [],
			contract_categories: [],
			allCampaigns: this.id ? null : [],
			retentions: [],
			categories: [],
			newId: this.id
		}
	},
	watch: {
		allCampaigns: function(data) {
			if (this.contractData.campaigns !== null && this.DualListOptions === null) {
				this.loadCampaignsList(data, this.contractData.campaigns)
			}
		},
		contractData: function(data) {
			if (this.id != null && this.allCampaigns !== null && this.DualListOptions === null) {
				this.loadCampaignsList(this.allCampaigns, data.campaigns)
			}
		},
		'contractData.email': function(newValue) {
			this.contractData.email = newValue.toLowerCase()
		},
		'contractData.applicant_email': function(newValue) {
			this.contractData.applicant_email = newValue.toLowerCase()
		}
	},
	computed: {
		...mapGetters({
			user: 'login/user'
		}),
		rules() {
			let validations = {
				contractData: {
					name: { required },
					phone: { required },
					email: { required, email },
					document: { required },
					organization_id: { required },
					signature_type: { required },
					contract_type: { required },
					comercial_base: { required },
					comercial_category_id: { required },
					delegation_id: { required },
					responsable_id: { required },
					domicilio: { required },
					zipcode: { required },
					poblacion: { required },
					contact_person: { required },
					team: { required },
					contract_category: { required },
					applicant_name: { required },
					applicant_email: { required, email },
					iban: { required, minLength: minLength(24) }
				},
				DualListOptions: {
					selectedItems: {
						required
					}
				}
			}

			if (this.contractData.contract_type == 1) {
				validations.contractData.contact_admon = { required }
				validations.contractData.representant_nif = { required }
				validations.contractData.representant_type = { required }
			}

			return validations
		}
	},
	props: {
		id: String
	},
	components: {
		PulseLoader,
		DualList
	},
	validations() {
		return this.rules
	},
	mixins: [single],
	methods: {
		sanitizeIban() {
			console.log('test')

			this.contractData.iban = this.contractData.iban.replace(/[^a-zA-Z0-9]/g, '') // Solo permite letras y números
		},
		loadCampaignsList(campaigns, selected) {
			this.loadDualList(
				campaigns,
				selected.map(cmp => campaigns.find(elem => elem.id == cmp.id)).filter(elem => elem != null)
			)
			if (this.id === undefined) {
				this.contractData.user_id = this.user.id
				this.contractData.applicant_name = this.user.name
				this.contractData.applicant_email = this.user.email
			}
		},
		file_upload(event) {
			if (event.target.files.length > 0) {
				this.file = event.target.files[0]
			}
		},
		file_reset() {
			this.file = null
		},
		addFile() {
			if (this.file)
				this.contractData.files.push({
					isNew: true,
					file: this.file
				})
			this.file = null
		},
		removeFile(file) {
			this.contractData.files.splice(file, 1)
		},
		async onRemoveFile(file) {
			this.startLoadingState()
			try {
				await this.$apollo.mutate(deleteContractFile(this.id, file.name))
				const index = this.contractData.files.findIndex(elem => elem.name == file.name)
				this.contractData.files.splice(index, 1)
			} catch (err) {
			} finally {
				this.stopLoadingState()
			}
		},
		onRequestSign() {
			this.startLoadingState()
			this.enableDisable = true
			this.$axios
				.put(`${process.env.VUE_APP_BTP_URL}/signature`, {
					contractId: parseInt(this.id || this.newId)
				})
				.then(() => {
					this.$alert('Solicitud enviada', '¡Enhorabuena!', 'success')
				})
				.catch(error => {
					if (error.status === 401) {
						this.$store.dispatch('login/logout')
					}
					let errorMessage
					if (error.response.status === 400) {
						errorMessage = error.response.data.errors[0].message
					} else {
						errorMessage = error.response.data.message
					}
					this.$alert(errorMessage || 'Error en la solicitud.', 'Error', 'error')
				})
				.finally(() => {
					this.stopLoadingState()
					this.enableDisable = false
				})
		},
		onCancelSign() {
			this.startLoadingState()
			this.$axios
				.delete(`${process.env.VUE_APP_BTP_URL}/signature`, {
					data: {
						contractId: parseInt(this.id || this.newId)
					}
				})
				.then(() => {
					this.$alert('Solicitud enviada', '¡Enhorabuena!', 'success')
				})
				.catch(error => {
					if (error.response.status === 401) {
						this.$store.dispatch('login/logout')
					}
					const errorMessage = error.message
					this.$alert(errorMessage || 'Error en la solicitud.', 'Error', 'error')
				})
				.finally(() => this.stopLoadingState())
		},
		onDownload() {
			window.open(`${process.env.VUE_APP_API_URL}/public/assets/files/?key=contracts_btp/${this.contractData.signature_nop}.pdf`)
		},
		ValidateNumber() {
			if (event.key != 'Backspace' && isNaN(event.key) && event.key != 'Tab') event.preventDefault()
		},
		async updateContract() {
			const mutationData = {
				contractId: this.newId,
				object: {
					...this.contractData,
					campaigns: undefined,
					files: undefined
				},
				contractCampaigns: this.getContractCampaigns(),
				contractFiles: await this.uploadFilesAndGetNewNames()
			}
			mutationData.object.email = mutationData.object.email.toLowerCase()
			mutationData.object.applicant_email = mutationData.object.applicant_email.toLowerCase()
			await this.$apollo.mutate(updateSingleContract(mutationData))
		},
		async insertNewContract() {
			const mutationData = {
				object: {
					...this.contractData,
					campaigns: undefined,
					files: undefined
				},
				contractCampaigns: this.getContractCampaigns(),
				contractFiles: await this.uploadFilesAndGetNewNames()
			}

			try {
				mutationData.object.email = mutationData.object.email.toLowerCase()
				mutationData.object.applicant_email = mutationData.object.applicant_email.toLowerCase()
				const result = await this.$apollo.mutate(insertSingleContract(mutationData))

				await this.$axios.post(`${process.env.VUE_APP_BTP_URL}/clickupTicket`, { contractId: result.data.insert_contracts_one.id })

				return result.data.insert_contracts_one.id
			} catch (error) {
				if (error.status === 401) {
					this.$store.dispatch('login/logout')
				}
				const errorMessage = error.message
				this.$alert(errorMessage || 'Error en la solicitud.', 'Error', 'error')
			}
		},
		async uploadFilesAndGetNewNames() {
			const newNames = await uploadFiles(
				this.contractData.files.filter(elem => elem.isNew).map(elem => elem.file),
				'contracts'
			)
			return [...this.contractData.files.filter(elem => !elem.isNew).map(elem => elem.name), ...newNames]
		},
		getContractCampaigns() {
			return this.DualListOptions.selectedItems
		},
		submit() {
			this.startLoadingState()
			this.$v.$touch()
			if (!this.$v.$invalid) {
				;(this.newId ? this.updateContract() : this.insertNewContract())
					.then(contractId => {
						this.$alert('Operación realizada exitosamente.', '¡Enhorabuena!', 'success')
						this.newId ? null : (this.newId = contractId)
						this.contractData.status = 'PEN'
					})
					.catch(error => {
						this.setError(error)
						const errorMessage = error.response.data.errors[0].message
						this.$alert(errorMessage || 'Error en la solicitud.', 'Error', 'error')
					})
					.finally(() => this.stopLoadingState())
			} else {
				this.setError(this.$t('form_validation'))
				this.$alert(this.$t('form_validation'), 'Advertencia', 'warning')
			}
		},
		submitAndRequestSign() {
			this.startLoadingState()
			this.$v.$touch()
			if (!this.$v.$invalid) {
				;(this.newId ? this.updateContract() : this.insertNewContract())
					.then(contractId => {
						this.$axios
							.put(`${process.env.VUE_APP_BTP_URL}/signature`, {
								contractId: parseInt(this.newId) || contractId
							})
							.then(() => {
								this.$alert('Solicitud enviada', '¡Enhorabuena!', 'success')
							})
							.catch(error => {
								if (error.response.status === 401) {
									this.$store.dispatch('login/logout')
								}
								let errorMessage
								if (error.response.status === 400) {
									errorMessage = error.response.data.errors[0].message
								} else {
									errorMessage = error.response.data.message
								}
								this.$alert(errorMessage || 'Error en la solicitud.', 'Error', 'error')
							})
					})
					.catch(error => {
						this.setError(error)
						const errorMessage = error.response.data.errors[0].message
						this.$alert(errorMessage || 'Error en la solicitud.', 'Error', 'error')
					})
					.finally(() => this.stopLoadingState())
			} else {
				this.setError(this.$t('form_validation'))
				this.$alert(this.$t('form_validation'), 'Advertencia', 'warning')
			}
		},
		copyForm() {
			const cleanData = {
				name: this.contractData.name,
				phone: this.contractData.phone,
				email: this.contractData.email,
				contract_type: this.contractData.contract_type,
				document: this.contractData.document,
				signature_type: this.contractData.signature_type,
				comercial_base: this.contractData.comercial_base,
				delegation_id: this.contractData.delegation_id,
				responsable_id: this.contractData.responsable_id,
				zipcode: this.contractData.zipcode,
				domicilio: this.contractData.domicilio,
				poblacion: this.contractData.poblacion,
				cellphone: this.contractData.cellphone,
				contact_person: this.contractData.contact_person,
				contact_admon: this.contractData.contact_admon,
				iban: this.contractData.iban,
				representant_nif: this.contractData.representant_nif,
				representant_type: this.contractData.representant_type,
				retention_id: this.contractData.retention_id,
				team: this.contractData.team,
				comercial_category_id: this.contractData.comercial_category_id,
				contract_category: this.contractData.contract_category,
				recommended: this.contractData.recommended,
				status: this.contractData.status,
				ahorreluz_code: this.contractData.ahorreluz_code,
				delivery_address: this.contractData.delivery_address,
				business_name: this.contractData.business_name,
				objective: this.contractData.objective
			}
			navigator.clipboard.writeText(window.btoa(JSON.stringify(cleanData)))
		},
		async pasteForm() {
			const importText = await navigator.clipboard.readText()
			try {
				const importData = JSON.parse(window.atob(importText))
				this.contractData.name = importData.name
				this.contractData.phone = importData.phone
				this.contractData.email = importData.email
				this.contractData.contract_type = importData.contract_type
				this.contractData.document = importData.document
				this.contractData.signature_type = importData.signature_type
				this.contractData.comercial_base = importData.comercial_base
				this.contractData.delegation_id = importData.delegation_id
				this.contractData.responsable_id = importData.responsable_id
				this.contractData.zipcode = importData.zipcode
				this.contractData.domicilio = importData.domicilio
				this.contractData.poblacion = importData.poblacion
				this.contractData.cellphone = importData.cellphone
				this.contractData.contact_person = importData.contact_person
				this.contractData.contact_admon = importData.contact_admon
				this.contractData.iban = importData.iban
				this.contractData.representant_nif = importData.representant_nif
				this.contractData.representant_type = importData.representant_type
				this.contractData.retention_id = importData.retention_id
				this.contractData.team = importData.team
				this.contractData.comercial_category_id = importData.comercial_category_id
				this.contractData.contract_category = importData.contract_category
				this.contractData.recommended = importData.recommended
				this.contractData.status = importData.status
			} catch (error) {
				this.$alert(error, 'Error', 'error')
			}
		}
	}
}
</script>

<style>
tr th {
	font-weight: 500;
	text-align: left;
	border-bottom: 1px solid black;
}

table tr:nth-child(even) {
	background: #f5f5f5;
}

td,
th {
	padding: 10px;
}

.d-block {
	display: block;
}

.f-bold {
	font-weight: bold;
}
</style>
